import api from 'shared/api';

export const patchCustomer = (customerId, data) => {
  const url = `/api/v1/customers/${customerId}`;
  return api.patch(url, data);
};
